import { useCallback } from 'react';
import { useAppSelector } from 'core/hooks/use-app-selector';
import { Navigate, Outlet, ScrollRestoration } from 'react-router-dom';
import type { Location } from 'react-router-dom';
import { RoutePaths } from 'core/models';
import { device } from 'core/styles/variables';
import { Toast } from 'hfs-common-ui';

import useMediaQuery from 'core/hooks/use-media-query';
import AboutSalesCompanyCodes from 'feature/auth/components/AboutSalesCompanyCodes';
import { useRouterAnalytics } from 'core/hooks/use-router-analytics';
import MaintenanceBanner from 'core/components/MaintenanceBanner';
import { MaintenanceEnum } from 'core/models/maintenance.model';
import Header from '../Header';
import useRestoreScroll from './hooks/use-restore-scroll';
import MobileNavMenu from '../MobileNavMenu';
import { ActiveModal } from '../reducer';
import * as S from './styled';

const RootLayout = () => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const isLoggingOut = useAppSelector((state) => state.auth.isLoggingOut);
  const isAboutSalesCompnyCodesOpen = useAppSelector((state) => state.auth.isOpenSalesCompanyCodesGuide);
  const activeModal = useAppSelector((state) => state.layout.activeModal);
  const restoreScroll = useRestoreScroll();
  const getScrollKey = useCallback(
    (location: Location) => (restoreScroll ? location.key : location.pathname),
    [restoreScroll]
  );
  const isDesktop = useMediaQuery(device.lg);
  useRouterAnalytics();

  if (!isAuthenticated && !isLoggingOut) {
    return <Navigate to={RoutePaths.UserLogin} replace />;
  }

  return (
    <>
      <MaintenanceBanner statusMode={MaintenanceEnum.SecuredMaintenanceBanner} />
      <S.StickyHeaderAreaDiv>
        <Header />
      </S.StickyHeaderAreaDiv>
      <Toast limit={0} />
      {activeModal === ActiveModal.SALES_COMPANY_CODE && isAboutSalesCompnyCodesOpen && <AboutSalesCompanyCodes />}
      <Outlet />
      <ScrollRestoration getKey={getScrollKey} storageKey="scroll-position" />
      {!isDesktop && <MobileNavMenu />}
    </>
  );
};

export default RootLayout;
